import { createUseInfiniteQuery } from "eddev/hooks";
import {
  UseInfiniteBlogsQuery,
  UseInfiniteBlogsQueryVariables,
  UseInfiniteCaseStudiesQuery,
  UseInfiniteCaseStudiesQueryVariables,
  UseInfiniteEventsQuery,
  UseInfiniteEventsQueryVariables,
  UseInfiniteInsightsQuery,
  UseInfiniteInsightsQueryVariables,
  UseInfiniteMarketguidesQuery,
  UseInfiniteMarketguidesQueryVariables,
  UseInfinitePaymentguidesCountriesQuery,
  UseInfinitePaymentguidesCountriesQueryVariables,
  UseInfinitePaymentguidesQuery,
  UseInfinitePaymentguidesQueryVariables,
  UseInfinitePressesQuery,
  UseInfinitePressesQueryVariables,
  UseInfinitePressNewsesQuery,
  UseInfinitePressNewsesQueryVariables,
} from "../types.graphql";

/**
 * DO NOT EDIT
 * This file is automatically generated by eddev
 * Any changes will be overwritten
 */

export const useInfiniteBlogs = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteBlogsQuery["blogs"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteBlogsQueryVariables
>({
  name: "UseInfiniteBlogs",
  defaultLimit: 20,
  paths: {
    "nodesPath": ["blogs", "nodes"],
    "pageInfoPath": ["blogs", "pageInfo"],
    "endCursorPath": ["blogs", "pageInfo", "endCursor"],
    "hasNextPagePath": ["blogs", "pageInfo", "hasNextPage"],
  },
});

export const useInfiniteCaseStudies = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteCaseStudiesQuery["caseStudies"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteCaseStudiesQueryVariables
>({
  name: "UseInfiniteCaseStudies",
  defaultLimit: 20,
  paths: {
    "nodesPath": ["caseStudies", "nodes"],
    "pageInfoPath": ["caseStudies", "pageInfo"],
    "endCursorPath": ["caseStudies", "pageInfo", "endCursor"],
    "hasNextPagePath": ["caseStudies", "pageInfo", "hasNextPage"],
  },
});

export const useInfiniteEvents = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteEventsQuery["events"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteEventsQueryVariables
>({
  name: "UseInfiniteEvents",
  defaultLimit: 20,
  paths: {
    "nodesPath": ["events", "nodes"],
    "pageInfoPath": ["events", "pageInfo"],
    "endCursorPath": ["events", "pageInfo", "endCursor"],
    "hasNextPagePath": ["events", "pageInfo", "hasNextPage"],
  },
});

export const useInfiniteInsights = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteInsightsQuery["insights"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteInsightsQueryVariables
>({
  name: "UseInfiniteInsights",
  defaultLimit: 20,
  paths: {
    "nodesPath": ["insights", "nodes"],
    "pageInfoPath": ["insights", "pageInfo"],
    "endCursorPath": ["insights", "pageInfo", "endCursor"],
    "hasNextPagePath": ["insights", "pageInfo", "hasNextPage"],
  },
});

export const useInfiniteMarketguides = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteMarketguidesQuery["marketguides"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteMarketguidesQueryVariables
>({
  name: "UseInfiniteMarketguides",
  defaultLimit: 20,
  paths: {
    "nodesPath": ["marketguides", "nodes"],
    "pageInfoPath": ["marketguides", "pageInfo"],
    "endCursorPath": ["marketguides", "pageInfo", "endCursor"],
    "hasNextPagePath": ["marketguides", "pageInfo", "hasNextPage"],
  },
});

export const useInfinitePaymentguides = createUseInfiniteQuery<
  Exclude<Exclude<UseInfinitePaymentguidesQuery["paymentguides"], undefined | null>["nodes"], undefined | null>,
  UseInfinitePaymentguidesQueryVariables
>({
  name: "UseInfinitePaymentguides",
  defaultLimit: 20,
  paths: {
    "nodesPath": ["paymentguides", "nodes"],
    "pageInfoPath": ["paymentguides", "pageInfo"],
    "endCursorPath": ["paymentguides", "pageInfo", "endCursor"],
    "hasNextPagePath": ["paymentguides", "pageInfo", "hasNextPage"],
  },
});

export const useInfinitePaymentguidesCountries = createUseInfiniteQuery<
  Exclude<
    Exclude<UseInfinitePaymentguidesCountriesQuery["paymentguidesCountries"], undefined | null>["nodes"],
    undefined | null
  >,
  UseInfinitePaymentguidesCountriesQueryVariables
>({
  name: "UseInfinitePaymentguidesCountries",
  defaultLimit: 10,
  paths: {
    "nodesPath": ["paymentguidesCountries", "nodes"],
    "pageInfoPath": ["paymentguidesCountries", "pageInfo"],
    "endCursorPath": ["paymentguidesCountries", "pageInfo", "endCursor"],
    "hasNextPagePath": ["paymentguidesCountries", "pageInfo", "hasNextPage"],
  },
});

export const useInfinitePresses = createUseInfiniteQuery<
  Exclude<Exclude<UseInfinitePressesQuery["presses"], undefined | null>["nodes"], undefined | null>,
  UseInfinitePressesQueryVariables
>({
  name: "UseInfinitePresses",
  defaultLimit: 20,
  paths: {
    "nodesPath": ["presses", "nodes"],
    "pageInfoPath": ["presses", "pageInfo"],
    "endCursorPath": ["presses", "pageInfo", "endCursor"],
    "hasNextPagePath": ["presses", "pageInfo", "hasNextPage"],
  },
});

export const useInfinitePressNewses = createUseInfiniteQuery<
  Exclude<Exclude<UseInfinitePressNewsesQuery["pressNewses"], undefined | null>["nodes"], undefined | null>,
  UseInfinitePressNewsesQueryVariables
>({
  name: "UseInfinitePressNewses",
  defaultLimit: 20,
  paths: {
    "nodesPath": ["pressNewses", "nodes"],
    "pageInfoPath": ["pressNewses", "pageInfo"],
    "endCursorPath": ["pressNewses", "pageInfo", "endCursor"],
    "hasNextPagePath": ["pressNewses", "pageInfo", "hasNextPage"],
  },
});
